/* eslint-disable react/prop-types */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import PopoverMenuButton from './PopoverMenuButton'

function PopoverMenuGroup(props) {
  const { group, employee, context, onAction, customActionHandlers, showIcons = false } = props
  const { title, items } = group

  // Filter out null/undefined items (from conditional rendering)
  const validItems = items.filter(Boolean)

  if (validItems.length === 0) {
    return null
  }

  return (
    <>
      {title && (
        <li
          className="nav__item nav__item--title fw-normal"
          style={{ padding: '0.375rem 1rem 0.25rem', fontSize: '1rem' }}
        >
          <FormattedMessage id={title} />
        </li>
      )}
      {validItems.map((item) => (
        <PopoverMenuButton
          key={item.id}
          item={item}
          employee={employee}
          context={context}
          onAction={onAction}
          customActionHandlers={customActionHandlers}
          showIcons={showIcons}
        />
      ))}
    </>
  )
}

export default PopoverMenuGroup
